import { DeviceFwUpdateInfo } from './device-fw-update-info.model';

export class DependentDeviceFwUpdateInfo extends DeviceFwUpdateInfo
{
    protected constructor(json: any = null)
    {
        super(json);
    }
}
